import gift1 from "../../images/gifts/gift_earring.jpg";
import gift2 from "../../images/gifts/gift_jewelry.jpg";
import gift4 from "../../images/gifts/gift_steel.jpg";
import gift5 from "../../images/gifts/gift_tie.jpg";

const AccessoriesProducts = [
  {
    image: gift1,
    name: "Women earrings",
    price: "$2.00 USD",
  },
  {
    image: gift2,
    name: "Women jewelry",
    price: "$4.00 USD",
  },
  {
    image: gift4,
    name: "Men steel",
    price: "$1.00 USD",
  },
  {
    image: gift5,
    name: "Green Men Tie",
    price: "$6.00 USD",
  },
];
export default AccessoriesProducts;
